<template>
  <div class="general-tab-cards">
    <accordion-panel
      class="general-tab-cards__cards-accordion"
      id="water-on-paper-cards"
      :collapsed.sync="collapsed"
    >
      <template #title>
        {{ $t('general.general') }}
      </template>
      <s-loader
        v-if="loading"
        class="my-5"
        size="lg"
      />
      <div
        v-else-if="cards.length"
        class="general-tab-cards__cards-wrapper"
      >
        <div
          v-for="card in cards"
          class="general-tab-cards__card"
          :key="card.name"
          :class="getCardClass(card)"
        >
          <div class="general-tab-cards__card-sensor">
            <sensor-icon
              :detail="card"
              :unique-id="createId()"
            />
          </div>
          <div class="general-tab-cards__card-tooltip">
            <info-badge
              v-if="card.ambientTemperatureLessThanFreeWaterTemperature"
              translation-key="messages.MI030.message"
            />
            <info-badge
              v-if="card.referenceTemperatureLessThanFreeWaterTemperature"
              translation-key="messages.MI034.message"
            />
          </div>
          <div class="text-center">
            <span class="general-tab-cards__card-value">
              {{ formatValue(card.value) || '-' }}
            </span>
            <span class="general-tab-cards__card-unit">
              {{ card.unit }}
            </span>
          </div>
          <div class="general-tab-cards__card-name">
            {{ card.name }}
          </div>
        </div>
      </div>
      <s-empty-list
        v-else
      />
    </accordion-panel>
  </div>
</template>

<script>
import AccordionPanel from '@/components/AccordionPanel';
import InfoBadge from '@/components/icon/InfoBadge';
import SensorIcon from '@/domain/components/installation/engineering/SensorIcon';
import { createId } from '@/services/createId';

export default {
  name: 'GeneralTabCardsSection',
  props: {
    cards: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InfoBadge,
    AccordionPanel,
    SensorIcon,
  },
  data: () => ({
    createId,
    collapsed: false,
  }),
  methods: {
    getCardClass(card) {
      return {
        'general-tab-cards__alarmed-card': card.alarmed,
      };
    },
    formatValue(value) {
      if (typeof value !== 'number') {
        return value;
      }
      return this.$n(value);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.general-tab-cards
  &__cards-accordion
    border: 1px solid $color-border-gray
    border-radius: 5px
  &__cards-wrapper
    width: 100%
    display: grid
    gap: 18px
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))
  &__alarmed-card
    border: none !important
    box-shadow: 0 0 3px var(--color-danger), inset 0 0 3px var(--color-danger)!important
  &__card
    position: relative
    padding: 10px
    border: 1px solid var(--color-border-dark)
    border-radius: 5px
    min-height: 160px
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
  &__card-sensor
    position: absolute
    top: 5px
    right: 7px
  &__card-tooltip
    position: absolute
    top: 5px
    left: 7px
  &__card-value
    font-size: 2.5em
  &__card-unit
    font-size: 1.8em
  &__card-name
    text-align: center
    margin-top: 10px
    font-size: .9em
    font-weight: bold
  ::v-deep
    .accordion-panel
      &__header
        padding: 2px 15px !important
        font-weight: bold
</style>
